import { LoadableAfterPaint } from '@confluence/loadable';

const ShortcutsProvider = LoadableAfterPaint({
	loader: () =>
		import(/* webpackChunkName: "loadable-ShortcutsProvider" */ './ShortcutsProvider.js'),
});

export default ShortcutsProvider;
